'use client'

/* ---------------------------------
Spinner
--------------------------------- */

import React from 'react'

type SpinnerProps = {
  size?: 'small' | 'medium' | 'large'
  color?: string
  className?: string
}

export default function Spinner({
  size = 'medium',
  color = 'currentColor',
  className = '',
}: SpinnerProps) {
  return (
    <div className={`spinner spinner--${size} ${className}`}>
      <div
        className='spinner__circle'
        style={{ borderTopColor: color }}
      />
    </div>
  )
}
